import React, { forwardRef, useImperativeHandle, useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Button from "react-bootstrap/Button";

const PresetModal = forwardRef(function Modal({ startingState = false, onClose, title, body, onButtonPress, buttonText, buttonStyle, allowScroll, hideXOverflow = false, children , style, ...props}, ref) {
    const [isOpen, setIsOpen] = useState(startingState);

    useEffect(() => {
        return () => {
            // Cleanup on unmount
            document.body.style.overflow = '';
        };
    }, []);

    useImperativeHandle(ref, () => ({
        open: () => {
            setIsOpen(true);
            document.body.style.overflow = 'hidden';
        },
        close: () => {
            document.body.style.overflow = '';
            setIsOpen(false);
        },
    }));

    const handleBackdropClick = () => {
        // console.log("clicked outside");
        document.body.style.overflow = '';
        setIsOpen(false);
        if (onClose) onClose();
    };

    const handleDialogClick = (event) => {
        // console.log("click in");
        event.stopPropagation();
    };

    return (
        <div className="PresetModal" style={hideXOverflow ? {overflowX: "hidden" } : {}}>
            <AnimatePresence>{isOpen && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, backdropFilter: "blur(6px)" }}
                    exit={{ opacity: 0 }}
                    transition={{duration: .25}}
                    // have to user styles here cause animating opacity and bgcolor uses opacity
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: "rgba(0, 0, 0, 0.65)",
                        zIndex: 1000,
                    }}
                    onClick={handleBackdropClick}
                >
                    <motion.div
                        {...props}
                        initial={{opacity: 0, x: "-50%", y: "0%", }}
                        animate={{opacity: 1, x: "-50%", y: "-50%"}}
                        exit ={{opacity: 0, x: "-50%", y: "0%"}}
                        transition={{delay: .25, transition: .3}}
                        style={{
                            border: 'none',
                            padding: "2rem",
                            zIndex: 1001,
                            background: 'white',
                            borderRadius: '10px',
                            position: 'absolute',
                            maxHeight: "100%",
                            maxWidth: "90%",
                            top: '50%',
                            left: '50%',
                            overflowY: 'scroll',
                            overflowX: hideXOverflow ? 'hidden' : 'inherit'
                        }}
                        onClick={handleDialogClick}
                    >
                        <div style={{ position: 'relative', height: '100%',
                            marginRight: '-12px', // this is the width of this modal's scroll bar
                            ...style}}>
                            {title && <h3 style={{textAlign: "center"}}>{title}</h3>}
                            {body && <p>{body}</p>}
                            {children}
                            <div style={{width: "100%", display: "flex", justifyContent: "right", gap: "8px"}}>
                                {onButtonPress && <Button
                                    style={buttonStyle}
                                    variant="primary"
                                    onClick={onButtonPress}
                                    className="preset-modal-button-button"
                                >
                                    {buttonText}
                                </Button>}
                            <Button
                                variant="danger"
                                className="preset-modal-cancel-button"
                                onClick={() => {
                                    document.body.style.overflow = '';
                                    setIsOpen(false);
                                    if (onClose) onClose();
                                }}
                            >
                                Close
                            </Button>
                            </div>
                        </div>
                    </motion.div>
                </motion.div>
            )}</AnimatePresence>
        </div>
    );
});

export default PresetModal;
